var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0011 2C6.47548 1.99777 2 6.45483 2 11.956C2 16.3062 4.79969 20.0041 8.69869 21.3622C9.22377 21.4935 9.14334 21.1217 9.14334 20.8679V19.1425C6.11127 19.4965 5.98838 17.4973 5.78505 17.1633C5.37392 16.4643 4.40197 16.2862 4.69244 15.9522C5.38286 15.5983 6.08669 16.0413 6.90225 17.2413C7.49212 18.1118 8.64283 17.9648 9.22601 17.8201C9.35337 17.2969 9.62596 16.8294 10.0013 16.4665C6.85979 15.9055 5.55044 13.9953 5.55044 11.7245C5.55044 10.6225 5.91465 9.6095 6.62965 8.79245C6.17384 7.44554 6.6721 6.29231 6.73914 6.12089C8.03731 6.00512 9.38688 7.04703 9.4919 7.1294C10.2292 6.93126 11.0716 6.82662 12.0145 6.82662C12.9619 6.82662 13.8065 6.93571 14.5506 7.13608C14.803 6.94462 16.0543 6.04964 17.2609 6.15873C17.3257 6.33016 17.8128 7.45667 17.3838 8.78577C18.1077 9.60505 18.4764 10.6269 18.4764 11.7312C18.4764 14.0065 17.1581 15.9188 14.0076 16.471C14.5327 16.9875 14.8589 17.7043 14.8589 18.4969V21.0015C14.8768 21.2019 14.8589 21.4 15.1941 21.4C19.1512 20.0709 22 16.3463 22 11.9583C22 6.45483 17.5223 2 12.0011 2Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.5ef9bc18431bb919ade90c9c8b47a342.svg";
export { ForwardRef as ReactComponent };